var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRaisingHand4Finger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.75C8.75 5.64543 7.85457 4.75 6.75 4.75C5.64543 4.75 4.75 5.64543 4.75 6.75V13.5C4.75 17.7802 8.21979 21.25 12.5 21.25C16.7802 21.25 20.25 17.7802 20.25 13.5V9C20.25 8.44772 19.8023 8 19.25 8C18.2065 8 17.2875 8.53275 16.75 9.3411M8.75 6.75V4.75C8.75 3.64543 9.64543 2.75 10.75 2.75C11.8546 2.75 12.75 3.64543 12.75 4.75V5.75M8.75 6.75V9.75M16.75 9.3411V5.75C16.75 4.64543 15.8546 3.75 14.75 3.75C13.6454 3.75 12.75 4.64543 12.75 5.75M16.75 9.3411C16.4341 9.81626 16.25 10.3866 16.25 11C16.25 11.6204 15.9245 12.1953 15.3925 12.5145L15.0362 12.7283C14.2383 13.207 13.75 14.0694 13.75 15M12.75 5.75V8.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisingHand4Finger);
export default __webpack_public_path__ + "static/media/raising-hand-4-finger.4a2e34980a0dc9368a7323b89ed31a8d.svg";
export { ForwardRef as ReactComponent };